import { BasicAsyncSelect } from "@/view/components/BasicAsyncSelect"
import { useFormContext } from "react-hook-form"
import { FilterFormData } from "./FilterReports"
import { useCallback } from "react"
import { MultiValue } from "react-select"
import { OptionType } from "@/app/utils/optionSelectType"
import { useSellers } from "@/app/hooks/useSellers"
interface SellersProps {
  opt: MultiValue<OptionType>
  setOpt: React.Dispatch<React.SetStateAction<MultiValue<OptionType>>>
  isCouponOrReferrals: boolean
}
export default function Sellers({
  opt,
  setOpt,
  isCouponOrReferrals,
}: SellersProps) {
  const {
    setValue,
    formState: { errors },
  } = useFormContext<FilterFormData>()

  const handleSelectSeller = (
    selectedSellerOptions: MultiValue<OptionType>,
  ) => {
    const value =
      selectedSellerOptions?.map((option) => option.value) || undefined

    setValue("sellerIds", value as unknown as string)
    setOpt(selectedSellerOptions)
  }

  const {
    data: fullSellerData,
    isFetching,
    isLoading,
    fetchNextPage,
    hasNextPage,
    setParams: setParamsSeller,
  } = useSellers({ initialLimit: 10 })

  const sellerData = fullSellerData?.pages.flatMap((page) =>
    page.users.map((user) => ({
      value: user._id,
      label: user.name,
    })),
  )

  const handleLoadMore = useCallback(() => {
    if (hasNextPage && !isFetching) {
      fetchNextPage()
    }
  }, [fetchNextPage, hasNextPage, isFetching])

  return (
    <div className={"space-y-2"}>
      <h3 className="font-medium text-black04">
        {isCouponOrReferrals ? "Vendedor" : "Vendedor"}
      </h3>
      <BasicAsyncSelect
        data={sellerData}
        handleSelectedValue={handleSelectSeller}
        isLoading={isFetching || isLoading}
        onMenuScrollToBottom={handleLoadMore}
        placeholder={
          isCouponOrReferrals
            ? "Selecione o(s) vendedor(es)"
            : "Selecione o(s) vendedor(es)"
        }
        setParams={setParamsSeller}
        value={opt}
        inputError={errors.sellerIds?.message}
      />
    </div>
  )
}
